import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

export default function Seletor({ title, options, selected, setSelected }) {
	return (
		<FormControl fullWidth>
			<InputLabel id="select-label" sx={{ margin: '5px' }}>{title}</InputLabel>
			<Select
				labelId="select-label"
				id="forecast-data-select"
				value={selected}
				label={title}
				onChange={e => setSelected(e.target.value)}
			>
				{options.map((option, idx) => <MenuItem key={idx} value={option.value}>{option.text}</MenuItem>)}
			</Select>
		</FormControl>
	)
} 